module.exports = __webpack_public_path__ + "media/images/DSC_1917-1af136f1f63d250764419ba265be2468.jpg";